<template>
  <div class="ly-table">
    <div class="ly-title">
      <h3 class="title-table">
        <slot></slot>
      </h3>
      <div class="table-toggle" v-if="toggle === true">
        <i class="el-icon-arrow-up" @click="clickToggle"></i>
      </div>
    </div>
    <div ref="content">
      <div class="ly-sort ly-sort-his">
        <span class="count">
          <p class="table-cell-all">
            {{ $t("messages.all") }} <span class="table-cell-count">97</span
            >{{ $t("messages.unit") }}
          </p>
        </span>
        <span>
          <el-upload
            :class="`ly-upload ${admin}`"
            :auto-upload="false"
            :on-change="handleChange"
            v-bind="$attrs"
            v-on="$listeners"
            :limit="1"
            action=""
          >
            <el-button
              size="small"
              type="plus"
              v-if="isWrite"
              :disabled="isTemplate"
              ><i class="icon-Plus"
            /></el-button>
          </el-upload>
        </span>
      </div>
      <idc-list :tableHeader="tableHeader" :tableData="tableData">
        <template #col1="{ scope }">
          <div class="border-box ctrt-upload">
            <idc-file-upload
              action=""
              :file-list="fileList"
              :on-exceed="handleExceed"
              :disabled="isTemplate"
            >
            </idc-file-upload>
          </div>
        </template>
        <template #col2="{ scope }">
          <el-button type="minus" v-if="isWrite" :disabled="isTemplate">
            <i class="icon-Minus" />
          </el-button>
        </template>
      </idc-list>
      <div class="btn-box">
        <el-button type="primary" v-if="isWrite" :disabled="isTemplate">{{
          $t("messages.btnSave")
        }}</el-button>
      </div>
    </div>
    <el-divider class="wrk-comp-divider" v-if="!toggleData"></el-divider>
  </div>
</template>

<script>
import IdcFileUpload from "@/components/common/IdcFileUpload.vue";
import IdcList from "@/components/common/IdcList";
export default {
  components: {
    IdcFileUpload,
    IdcList,
  },
  props: {
    admin: {
      type: String,
      default: "",
    },
    openToggle: {
      value: Boolean,
      dafault: false,
    },
    isWrite: {
      type: Boolean,
      default: true,
    },
    isTemplate: {
      type: Boolean,
      default: true,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    prcssTrtDataCnctId: {
      type: String,
      default: "",
    },
    exeWflowId: {
      type: String,
      default: "",
    },
    idcCd: {
      type: String,
      default: "",
    },
    ticketInfo: {
      type: Object,
      default: () => {},
    },
    //상위 공정 ID
    mainPrcssId: { 
      type: String,
      default: "",
    },
    //하위 공정 ID
    subPrcssId: {
      type: String,
      default: "",
    },
    scrnId: {
      type: String,
      default: "",
    },
    wflowScrnId: {
      type: String,
      default: ''
    },
    scrnGetApi: {
      type: String,
      default: ''
    },
    scrnPostApi: {
      type: String,
      default: ''
    },
    scrnPutApi: {
      type: String,
      default: ''
    },
    scrnDeleteApi: {
      type: String,
      default: ''
    },
    wflowScrnId: {
      type: String,
      default: "",
    },
    mandDataChkYn:{
      type: String,
      default: 'N'
    },
    sftyChkMandChkYn: {
      type: String,
      default: 'N'
    },
    sftyChkScrnYn: {
      type: String,
      default: 'N'
    },
    callDate: {
      type: Number,
      default: -1
    },
    stepCd: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {  
      fileList: [
        {
          name: "food.jpeg",
          url: "",
        },
      ],
      toggleData: true,
      toggle: this.openToggle,
      tableHeader: [
        {
          type: "selection",
          align: "left",
        },
        {
          prop: "col1",
          label: "파일명",
          columnType: "custom",
          width: "18",
        },
        {
          prop: "col2",
          label: "",
          columnType: "custom",
          width: "1",
        },
      ],
      tableData: [
        {
          col1: null,
          col2: null,
        },
        {
          col1: null,
          col2: null,
        },
      ],
    };
  },
  watch: {
    
  },
  methods: {
    handleChange(file, fileList) {
      this.$emit("handleChange", file, fileList);
    },
    chkValidateData() {
      if(this.mandDataChkYn != 'Y'){
        return true;
      }
      if(this.prcssTrtDataCnctId != null && this.prcssTrtDataCnctId != ''){
        return true;
      } else {
        return false;
      }
    },
    getTemplateData() {
      // 상위 컴포넌트에서 호출
      // Axios로 저장 시 넘겨줄 데이터를 리턴하면 됨.
      return "";
    },
    clickToggle(e) {
      if (this.toggleData) {
        this.$refs.content.style = "display: none";
        e.target.className = "el-icon-arrow-down";
      } else {
        this.$refs.content.style = "display: block;";
        e.target.className = "el-icon-arrow-up";
      }
      this.toggleData = this.toggleData ? false : true;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `The limit is 3, you selected ${
          files.length
        } files this time, add up to ${files.length + fileList.length} totally`
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-box {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.ctrt-upload {
  width: 100%;
}
.border-box {
  padding: 5px 5px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid $--color-light-gray;
}
</style>
